import { useCallback, useLayoutEffect, useRef } from "react"

type AnyFn = (...args: never[]) => unknown

export function useCallbackRef<T extends AnyFn>(callback: T | undefined) {
  const callbackRef = useRef(callback)

  useLayoutEffect(() => {
    callbackRef.current = callback
  }, [callback])

  return useCallback((...args: Parameters<T>): ReturnType<T> | undefined => {
    const currentCallback = callbackRef.current as
      | ((...callbackArgs: Parameters<T>) => ReturnType<T>)
      | undefined

    return currentCallback?.(...args)
  }, [])
}
